import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { PreCandidato } from 'src/app/models/preCandidato.model';
import { PreCandidatoCsvDTO } from 'src/app/models/preCandidatoCsvDTO.model';
import { PreCandidatosService } from 'src/app/services/precandidatos.service';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import { Utils } from 'src/app/utils/utils';
import { ActivatedRoute, Router, NavigationExtras, ParamMap } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import jwt_decode from "jwt-decode";

declare var window: any;
@Component({
  selector: 'app-formulario-precandidato',
  templateUrl: './formulario-precandidato.component.html',
  styleUrls: ['./formulario-precandidato.component.css']
})
export class FormularioPreCandidatoComponent implements OnInit {
  idEleicao: any;
  novoPreCandidato: any;
  preCandidato: any;
  formPreCadastroCandidato: FormGroup;
  token: any;
  idCandidatura: any;
  listaCargos: any[] = [];
  select: FormGroup;
  btOff: boolean = false;
  list: any;
  public imageSrc: string = '';
  votoJustificavel: boolean = false;
  parametroJustificativa: any;
  isSubmit: boolean = false;
  formModal: any;
  validaEmail: boolean = true;
  validaFoto: boolean;
  validaTamanhoFoto: boolean;
  eleicaoRota: any;
  loginService: LoginService;
  informacoesToken: any;
  logoEleicao: string;

  constructor(
    public route: ActivatedRoute,
    public eleicaoService: EleicaoService,
    public candidaturaService: CandidaturaService,
    public precanditadosService: PreCandidatosService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    public router: Router,
    private formBuilder: FormBuilder,
    public utils: Utils,
    protected auth: LoginService,
  ) {
    this.eleicaoRota = this.route.snapshot.params.eleicaoRota;
  }

  async ngOnInit() {
    this.spinner.show();
    this.eleicaoRota = JSON.parse(sessionStorage.getItem("eleicaoRota"));
    this.token = sessionStorage.getItem("token");
    var infoPrecandidato = JSON.parse(sessionStorage.getItem("infoPrecandidato"));
    if(!infoPrecandidato){
      this.router.navigate(["../../acesso-negado"], { relativeTo: this.route });
    }
    var idPreCandidato = Number(infoPrecandidato.id);
    this.idEleicao = Number(infoPrecandidato.idEleicao);
    this.novoPreCandidato = new PreCandidato;   
    this.token = sessionStorage.getItem("token");
    this.listarCargosEleicao();
    this.formPreCadastroCandidato = new FormGroup({
      nome: new FormControl(),
      emailPreCandidato: new FormControl(),
      cpf: new FormControl(),
      precandidatocurriculum: new FormControl(),
      cargo: new FormControl()
    });
    this.formPreCadastroCandidato = this.formBuilder.group({
      nome: ['', [Validators.required, this.utils.noWhitespaceValidator]],
      cpf: [null, this.isValidCPF],
      emailPreCandidato: ['', Validators.required],
      precandidatocurriculum: ['', Validators.required],
      votoJustificavel: ['false'],
      cargo: ['', [Validators.required]]
    });
    this.select = this.formBuilder.group({
      select: ['']
    });
    this.formModal = new window.bootstrap.Modal(
      document.getElementById('myModal2')
    );
    this.precanditadosService.getPreCandidadosById(infoPrecandidato.id, this.token).then((res: any) => {
      this.formPreCadastroCandidato.patchValue(res);
      this.formPreCadastroCandidato.get("emailPreCandidato").patchValue(res.email);
      this.formPreCadastroCandidato.get("precandidatocurriculum").patchValue(res.curriculum);
      this.formPreCadastroCandidato.get("cargo").patchValue(res.cargoId);
      this.idCandidatura = res.candidaturaId;
      this.preCandidato = res;
      this.imageSrc = res.imagem;
      this.spinner.hide();
    }, err => {
      this.router.navigate(["../../acesso-negado"], { relativeTo: this.route });
    })
    this.spinner.hide();
    this.route.params.subscribe(async params => {
      if (params.rotaEleicao && params.rotaEleicao != "gestor" && params.rotaEleicao != "admin" ) {
        this.getLogoEleicao(params.rotaEleicao);
      }
    });
  }

  public listarCargosEleicao() {
    this.eleicaoService.getCargosByIdEleicao(this.idEleicao, this.token).then((res: []) => {
      if (res != null && res.length > 0) {
        this.listaCargos = res;
      } else {
        this.messageService.add({ key: 'toast', severity: 'info', summary: 'Informação', detail: 'Ainda não existem cargos cadastros para essa eleição' });
      }
    })
  }

  // o submit chama a abertura do modal e as funçooes do sim ou não seguem com o envioCandidato

  validaCurriculo() { // chamado no click do submit
    if (this.formPreCadastroCandidato.get("precandidatocurriculum").value == null || this.utils.noWhitespaceValidatorString2(this.formPreCadastroCandidato.get("precandidatocurriculum").value)) {
      this.formModal.show(); //se o campo curriculum estiver vazio, abre o modal com as opções
    } else {
      this.envioPreCandidato(); // se não estiver vazio, ele faz o envio/persistência
    }
  }
  prosseguirSemCurriculum() { //ao clicar em "SIM" no modal
    this.formModal.hide();
    this.envioPreCandidato(); // submete
  }
  pararSubmit() { // ao clicar "Não"
    this.formModal.hide();
    return false; // para aqui e não executa nenhuma ação
  }

  public envioPreCandidato() {
    this.isSubmit = true;
    this.validarEmailPreCandidato(this.formPreCadastroCandidato.get('emailPreCandidato').value);
    this.validarFoto();
    this.validarTamanhoFoto();
    if (!this.formPreCadastroCandidato.valid) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Corrija o(s) erro(s) apontado(s) no formulário!" })
    }
    else if (this.validaEmail == false) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor, preencha um Email válido para o pré-candidato' });
    } else if (this.validaFoto == false){
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor, adicione uma foto para o pré-candidato' });
    } else if (this.validaTamanhoFoto == false){
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor, adicione uma foto de até 3.5 MB para o pré-candidato' });
    } else {
      this.novoPreCandidato.votoJustificavel = this.formPreCadastroCandidato.get("votoJustificavel").value;
      this.novoPreCandidato.parametroJustificativa = this.formPreCadastroCandidato.get("votoJustificavel").value == 'true' ? this.formPreCadastroCandidato.get("parametroJustificativa").value : '';
      if (this.novoPreCandidato.votoJustificavel === 'true' && (this.novoPreCandidato.parametroJustificativa == null || this.novoPreCandidato.parametroJustificativa.trim() == '')) {
        return this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Atenção', detail: "É necessário preencher o campo parametro justificativa caso o voto seja justificável." })
      }

      this.novoPreCandidato.email = this.formPreCadastroCandidato.get("emailPreCandidato").value;
      this.novoPreCandidato.nome = this.formPreCadastroCandidato.get("nome").value;
      this.novoPreCandidato.cpf = this.formPreCadastroCandidato.get("cpf").value;
      this.novoPreCandidato.curriculum = this.formPreCadastroCandidato.get("precandidatocurriculum").value;
      this.novoPreCandidato.eleicao = { id: this.idEleicao };
      this.novoPreCandidato.imagem = this.imageSrc;
      this.novoPreCandidato.cargoId = this.formPreCadastroCandidato.get("cargo").value;
      const cargo = this.listaCargos.find(cargo => cargo.id == this.novoPreCandidato.cargoId );
      sessionStorage.setItem("cargo", cargo.nome);
      this.novoPreCandidato.candidatura = { "id": this.idCandidatura };
    }

    this.precanditadosService.editarPreCandidatoFormulario(this.novoPreCandidato, this.token, this.preCandidato.id).then(() => { //endpoint de edição.
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Editado com sucesso!' });
      sessionStorage.setItem("preCandidato", JSON.stringify(this.novoPreCandidato));
      this.router.navigate(['realizada'], {relativeTo: this.route});
      // this.fixAlterarImg(document.getElementById("imagePreCandidato"));
      this.isSubmit = false;
      // this.cancelarEdicao();
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
    })
  }

  validarFoto(){
    this.validaFoto = !(this.imageSrc == null || this.imageSrc =="") ;
  }

  validarTamanhoFoto(){
    if(this.validaFoto){
      var tamanhoMaximo = 3.5;
      var base64Length = this.imageSrc.length;
      var contaPadding = (this.imageSrc.match(/=*$/)[0] || '').length;
      var tamanhoEstimado = (base64Length * 3 / 4) - contaPadding;
      var tamanhoEstimadoMb = tamanhoEstimado / 1048576;
      this.validaTamanhoFoto = tamanhoEstimadoMb <= tamanhoMaximo;
    }
  }

  validarEmailPreCandidato(email: string) {
    const expressaoRegularEmail = /\S+@\S+\.\S+/;
    if(email === null || email === "" || email === undefined){
      this.validaEmail = true
    }
    else {
      if (expressaoRegularEmail.test(email) == false && email != '' && email != null) {
        this.validaEmail = false;
      } else {
        this.validaEmail = true;
      }
    }
  }
  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    let reader = e.target;
    this.imageSrc = reader.result;
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '150px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    uploadUrl: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertVideo']
    ]
  };

  public fixAlterarImg(input: any) {
    this.imageSrc = '';
    input.value = '';
  }

  baixarTemplate() {
    let csvHeader = 'nome;cpf;cargo;curriculo;votoJustificavel;parametrojustificativa;email'
    this.utils.baixarModeloCsv(csvHeader, "precandidato")
  }

  isValidCPF(control: FormControl) {
    let cpf = (control.value || '');
    if (!cpf) {
      return null;
    }
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '' || cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999") {
      return { 'invalid': true };
    }
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(9))) {
      return { 'invalid': true };
    }

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(10))) {
      return { 'invalid': true };
    }
    return null;
  }
  async getLogoEleicao(rota: string) {
    try {
      const request = await this.eleicaoService.getLogoByRotaEleicao(rota).toPromise();
      if (request) {
        this.eleicaoService.logoEleicao = request;
        sessionStorage.setItem('logoEleicao', request);
      }
    } catch (error) {
      console.log(error);
    }
  }
}
